// Kicks off the Emergent-managed Google OAuth flow.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleSignIn = () => {
  const redirectUrl = window.location.origin + '/auth/google/callback';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

// iOS Safari / iOS PWA-safe redirect flow.
//
// Google Identity Services popups (used by @react-oauth/google) are unreliable
// on iOS Safari and completely broken inside a standalone iOS PWA: the popup
// either opens as a background tab that never postMessages back, or Safari
// blocks it silently — the caller is stuck on "Opening Google…" forever.
//
// This helper does a full-page redirect to accounts.google.com with
// response_type=token, then relies on GoogleAuthCallback to pick up the
// access_token from the URL fragment on return. The redirect_uri here is
// the SAME one used by AppGoogleLoginPage's WebView flow, so it's already
// registered in the Google Cloud OAuth Client and works end-to-end.
export const startGoogleSignInIOSRedirect = () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const callbackOrigin = process.env.REACT_APP_OAUTH_CALLBACK_ORIGIN || window.location.origin;
  if (!clientId) {
    // No custom client ID configured — fall back to Emergent-managed flow.
    startGoogleSignIn();
    return;
  }
  const redirectUri = `${callbackOrigin}/auth/google/callback`;
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'token',
    scope: 'openid email profile',
    include_granted_scopes: 'true',
    // Force account picker so users can switch accounts on iOS just like
    // they can on Android's native picker.
    prompt: 'select_account',
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};
